<template>
  <div id="supplier">
      <big-title>Nuevo proyecto</big-title>
      <vx-card title="Card Title">
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
        quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
        cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        <template slot="footer">
          <div class="flex justify-between">
            <vs-button @click="goToDetail()">Crear</vs-button>                    
          </div>
        </template>
      </vx-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      project: "nuevo",
      status: "",
      allowed: null,
      loading: false,
    };
  },
  components: {
  },
  computed: {
    ...mapState("auth", ["user"]),
    userId: function() {
      return this.user === null ? 0 : this.user.user_id;
    }   
  },
  methods:{
    goToDetail(){
      this.$vs.loading()
      setTimeout( ()=> {
        this.$vs.loading.close();
        this.$router.replace({ name: 'detalleProyectoSolicitante', params: { id: 868 } });        
      }, 2000);
    }
  }
};
</script>

allowed="{{$data['verified']}}"